export const IS_LOGGED_IN = '/api/auth/is-logged-in'

export const AUTH_LOGIN = '/api/auth/login'

export const QLIK_AUTH = '/api/auth/qlik-auth'

export const AUTH_LOGOUT = '/api/auth/logout'

export const HANDOFF_TOKEN = '/api/auth/handoff-token'

export const JWT_LOGIN = '/api/auth/sso/jwt'

export const PL_LOGIN = '/api/auth/sso/pl/login'
export const PL_SAML_AUTHENTICATE = '/api/auth/sso/pl/authenticate'

export const TCP_LOGIN = '/api/auth/sso/tcp/login'
export const TCP_SAML_AUTHENTICATE = '/api/auth/sso/tcp/authenticate'

export const ADD_USER = '/api/user/add-user'
export const DISABLE_USER = '/api/user/disable-user'

export const SESSION_ROUTES_TO_IGNORE = [
  AUTH_LOGIN,
  JWT_LOGIN,
  PL_LOGIN,
  PL_SAML_AUTHENTICATE,
  TCP_LOGIN,
  TCP_SAML_AUTHENTICATE
]

export const DELETE_USER = '/api/user/delete-user'
export const GET_USERS = '/api/user/get-users'
export const GET_ALL_USERS = '/api/user/get-all-users'
export const EDIT_USER = '/api/user/edit-user'
export const SEARCH_USERS = '/api/user/search-users'
export const GET_USER_TYPES = '/api/user/get-user-types'
export const UPDATE_EMAIL_PREFERENCE = '/api/user/update-email-preference'
export const UPDATE_LOCATION_PREFERENCE = '/api/user/update-location-preference'
export const UPDATE_TC = '/api/user/update_tc'

export const GET_ALL_ORGANISATIONS = '/api/organisation/get-all-organisations'

export const GET_ARTICLES = '/api/article/get-articles'
export const GET_ARTICLE = '/api/article/get-article'
export const DELETE_ARTICLE = '/api/article/delete-article'
export const ADD_ARTICLE = '/api/article/add-article'
export const PUBLISH_ARTICLE = '/api/article/publish-article'
export const PIN_ARTICLE = '/api/article/pin-article'
export const GET_LATEST_ARTICLES = '/api/article/get-latest-articles'
export const EDIT_ARTICLE = '/api/article/edit-article'
export const GET_PREVIEW_ARTICLES = '/api/article/get-preview-articles'
export const FILTER_PREVIEW_ARTICLES = '/api/article/filter-preview-articles'
export const SEARCH_ARTICLES = '/api/article/search-articles'
export const GET_ARTICLE_DESCRIPTION = '/api/article/get-article-description'
export const GET_TEMPLATES = '/api/article/get-templates'
export const GET_POTENTIAL_AUTHORS = '/api/article/get-potential-authors'
export const EDIT_AUTHOR = '/api/article/edit-author'

export const GET_ATTACHMENTS = '/api/article/get-attachments'
export const DOWNLOAD_ATTACHMENT = '/api/article/download-attachment'
export const UPLOAD_ATTACHMENT = '/api/article/upload-attachment'
export const EDIT_ATTACHMENT = '/api/article/edit-attachment'
export const DELETE_ATTACHMENT = '/api/article/delete-attachment'

export const DOWNLOAD_LICENCE = '/api/article/download-licence'

export const ADD_CATEGORY = '/api/category/add-category'
export const GET_CATEGORIES = '/api/category/get-categories'
export const ADD_SUB_CATEGORY = '/api/category/add-sub-category'
export const EDIT_CATEGORY = '/api/category/edit-category'
export const EDIT_SUB_CATEGORY = '/api/category/edit-sub-category'
export const DELETE_CATEGORY = '/api/category/delete-category'
export const DELETE_SUB_CATEGORY = '/api/category/delete-sub-category'
export const SEARCH_CATEGORIES = '/api/category/search-categories'
export const SAVE_CATEGORIES_ORDER = '/api/category/save-categories-order'

export const ADD_DATASET = '/api/dataset/add-dataset'
export const EDIT_DATASET = '/api/dataset/edit-dataset'
export const GET_DATASETS = '/api/dataset/get-datasets'
export const SEARCH_DATASETS = '/api/dataset/search-datasets'
export const DOWNLOAD_DATASET = '/api/dataset/download-datasets'

export const ADD_DISCOVERY = '/api/discovery/add-discovery'
export const EDIT_DISCOVERY = '/api/discovery/edit-discovery'
export const GET_DISCOVERIES = '/api/discovery/get-discoveries'
export const SEARCH_DISCOVERIES = '/api/discovery/search-discoveries'
export const DOWNLOAD_DISCOVERIES = '/api/discovery/download-discoveries'

export const ADD_INSIGHT = '/api/insight/add-insight'
export const EDIT_INSIGHT = '/api/insight/edit-insight'
export const GET_INSIGHTS = '/api/insight/get-insights'
export const SEARCH_INSIGHTS = '/api/insight/search-insights'
export const DOWNLOAD_INSIGHTS = '/api/insight/download-insights'

export const ADD_WEBPAGE = '/api/webpage/add-webpage'
export const EDIT_WEBPAGE = '/api/webpage/edit-webpage'
export const GET_WEBPAGES = '/api/webpage/get-webpages'
export const SEARCH_WEBPAGES = '/api/webpage/search-webpages'
export const DOWNLOAD_WEBPAGES = '/api/webpage/download-webpages'

export const EDIT_SITE = '/api/site/edit-site'
export const GET_SITES = '/api/site/get-sites'
export const GET_POSSIBLE_SITES = '/api/site/get-possible-sites'
export const GET_SITE = '/api/site/get-site'
export const SEARCH_SITES = '/api/site/search-sites'
export const PUBLISH_SITE = '/api/site/publish-site'
export const ADD_SITE = '/api/site/add-site'
export const DELETE_SITE = '/api/site/delete-site'
export const ADD_PERMITTED_GROUP = '/api/site/add-permitted-group'
export const DELETE_PERMITTED_GROUP = '/api/site/delete-permitted-group'
export const EDIT_PERMITTED_GROUP = '/api/site/edit-permitted-group'

export const EDIT_HELP = '/api/help/edit-help'
export const GET_HELP = '/api/help/get-help'

export const SEARCH_ALL = '/api/search/search-all'

export const GET_ALL_TAGS = '/api/tag/get-all-tags'
export const ADD_TAG = '/api/tag/add-tag'
export const EDIT_TAG = '/api/tag/edit-tag'
export const DELETE_TAG = '/api/tag/delete-tag'
export const SEARCH_TAGS = '/api/tag/search-tags'

export const GET_CAROUSEL_INFORMATION = '/api/carousel/get-carousel-information'

export const ADD_URL_CHANGE = '/api/metrics/add-url-change'

export const CHECK_DB_WRITE = '/api/health/check-db-write'
